<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  computed: {
    ...mapGetters(['token'])
  },
  watch: {
    // token: {
    //   handler: function (val) {
    //     if (val) {
    //       var value = val.accessToken ?? ''
    //       if (value) this.$signalr.start()
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
}
</script>

<style>
@import '@/assets/style/common.css';
@import '@/assets/style/table.css';
@import '@/assets/style/transition.css';
@import '@/assets/style/iconfont.css';
/* @import url('http://at.alicdn.com/t/c/font_3370829_jjy44fnrhaa.css'); */
</style>

<style lang="scss">
  // @import url('@/assets/style/index.scss');
</style>
